'use strict';
var app = require('angular').module('login', []);

app.controller('loginCtrl', ['$state', '$http', 'Authentication', '$timeout', require('./loginCtrl')]);
app.config(['$stateProvider', require('./loginConfig')]);
